<app-config-top-nav></app-config-top-nav>

<div class="worker-types-container">
  <!-- Loading -->
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner"></div>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <!-- Header -->
  <div class="header" *ngIf="!isLoading">
    <h2>Worker Types</h2>

    <div class="header-actions">
      <button class="btn btn-primary" (click)="openCreateModal()">+ New Worker Type</button>
      <button class="btn btn-primary" (click)="goToImport()">Import Worker Types</button>
    </div>
  </div>

  <!-- Sticky Pagination -->
  <div class="pagination sticky" *ngIf="!isLoading">
    <div class="page-controls">
      <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">Prev</button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
        Next
      </button>
    </div>

    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize(pageSize)">
        <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
      </select>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters-container" *ngIf="!isLoading">
    <div class="filters-row">
      <label class="filter-field search-field">
        <app-search-bar [value]="filters.searchTerm" [debounceMs]="600" placeholder="Search worker type name"
          (searchChange)="onSearchTermChange($event)">
        </app-search-bar>
      </label>
    </div>
  </div>

  <!-- Worker Types List -->
  <div class="worker-types-list">
    <div *ngFor="let wt of workerTypes$ | async" class="worker-type-row">
      <div class="worker-type-info">
        <div class="worker-type-name">{{ wt.name }}</div>
        <div class="worker-type-description">{{ wt.description || '' }}</div>
      </div>

      <div class="worker-type-actions">
        <button class="btn edit" (click)="openEditModal(wt)">Edit</button>
        <button class="btn delete" (click)="confirmDelete(wt)">Delete</button>
      </div>
    </div>
  </div>

  <!-- Create/Edit Modal -->
  <div *ngIf="modalOpen" class="modal-backdrop">
    <div class="modal worker-type-modal" (click)="$event.stopPropagation()">
      <h2>{{ isEditMode ? 'Edit Worker Type' : 'New Worker Type' }}</h2>

      <form #workerTypeForm="ngForm" (ngSubmit)="submitWorkerType(workerTypeForm)">
        <label for="workerTypeName">Name</label>
        <input id="workerTypeName" type="text" [(ngModel)]="formModel.name" name="name" required />

        <label for="workerTypeDescription">Description</label>
        <textarea id="workerTypeDescription" [(ngModel)]="formModel.description" name="description">
        </textarea>

        <div class="modal-buttons">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
          <button type="submit" class="btn btn-primary">
            {{ isEditMode ? 'Update' : 'Create' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Delete Modal -->
  <div *ngIf="deleteConfirmOpen" class="modal-backdrop">
    <div class="modal confirm-modal" (click)="$event.stopPropagation()">
      <h2>Delete Worker Type</h2>
      <p class="modal-text">
        Are you sure you want to delete <strong>{{ workerTypeToDelete?.name }}</strong>?
      </p>

      <div class="modal-buttons confirm-buttons">
        <button type="button" class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="deleteWorkerType()">Delete</button>
      </div>
    </div>
  </div>

  <!-- Toast -->
  <div *ngIf="toastVisible" class="toast" [ngClass]="toastType">
    <img class="icon" alt="icon" />
    <span>{{ toastMessage }}</span>
  </div>
</div>